import React from "react";
import styled from "styled-components";
import { Element } from "react-scroll";
import ReactMarkdown from "react-markdown";
import baseStyles from "../../styles/baseStyles";

const Card = styled.div`
  width: 60%;
  position: relative;
  @media (max-width: 48em) {
    margin: auto;
    width: 80%;
  }
  @media (max-width: 425px) {
    width: 100%;
  }
`;

const CategoryTitle = styled.h2`
  font-family: Futura;
  color: rgba(37, 42, 43, 0.75);
  margin: 0;
`;

const ArticleTitle = styled.h3`
  font-family: Lato;
  font-size: 15px;
  color: rgba(37, 42, 43, 0.75);
  letter-spacing: 1.33px;
`;

const ArticleBody = styled(ReactMarkdown)`
  font-family: Lato;
  font-size: 1rem;
  color: rgba(37, 42, 43, 0.75);
  a {
    color: ${baseStyles.color.primary};
    text-decoration: none;
  }
  img {
    width: 100%;
    height: auto;
    margin: 1rem 0;
    border-radius: 5px;
  }
`;

const Category = styled.div``;
const Article = styled.div``;

const showArticles = articles =>
  articles.map(({ title, body }) => (
    <Element name={title} key={title}>
      <Article>
        <ArticleTitle>{title}</ArticleTitle>
        <ArticleBody source={body} />
      </Article>
    </Element>
  ));

const MainContent = ({ contentCategories }) => (
  <Card>
    {contentCategories
      ? contentCategories.map(({ title, articles }) => (
          <Element name={title} key={title}>
            <Category key={title}>
              <CategoryTitle>{title}</CategoryTitle>
              {showArticles(articles)}
            </Category>
          </Element>
        ))
      : null}
  </Card>
);

export default MainContent;



// WEBPACK FOOTER //
// ./src/components/MainContent/index.js